import { render, staticRenderFns } from "./chartThree.vue?vue&type=template&id=067d9a42&scoped=true"
import script from "./chartThree.vue?vue&type=script&lang=js"
export * from "./chartThree.vue?vue&type=script&lang=js"
import style0 from "./chartThree.vue?vue&type=style&index=0&id=067d9a42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d9a42",
  null
  
)

export default component.exports